<template>
  <div :class="proyect_name">
    <default-layout>
      <router-view></router-view>
    </default-layout>
  </div>
</template>

<script setup lang="ts">
import { proyect_name } from '../config'
import DefaultLayout from './micro/layouts/MainLayout.vue'

import { setCookie } from './micro/common/cookie'
import { onBeforeMount } from 'vue'

onBeforeMount(() => {
  setCookie('CHAT_COOKIE', 'initial')
})
</script>

<style scoped></style>
